import { useEffect, useState } from 'react';

import { timeBetween } from '@vimeo/core/libs/date/date';

import { interactionToolsConfig } from '../../../../configs/InteractionToolsConfig';
import { T_JUST_NOW } from '../../../../translations';
import { registerInterval, unRegisterInterval } from '../../../../utils/general/timers';

function calculateQuestionTimeAsked(createdAt: number): string {
  const now = new Date();
  const diffMs = now.getTime() - createdAt;

  if (diffMs < interactionToolsConfig.QNA.JUST_NOW_THRESHOLD) {
    return T_JUST_NOW;
  }

  return timeBetween(new Date(createdAt), now);
}

export function useQuestionTimeAsked(createdAt: number): string {
  const [timeAsked, setTimeAsked] = useState<string>(() => calculateQuestionTimeAsked(createdAt));

  useEffect(() => {
    setTimeAsked(calculateQuestionTimeAsked(createdAt));

    const intervalId: number = registerInterval(
      () => setTimeAsked(calculateQuestionTimeAsked(createdAt)),
      interactionToolsConfig.QNA.QNA_POSTED_AT_REFRESH_PERIOD,
      'questionItem',
    );

    return () => unRegisterInterval(intervalId);
  }, [createdAt]);

  return timeAsked;
}
